module.exports = __webpack_public_path__ + "fa-solid-900.ttf?3a6ff68146d68033d0c4bd44783ee343";